<template>
  <div class="table-scroll-wrapper">
    <table class="history-table">
      <thead>
        <tr>
          <th
            class="text-white"
            v-for="(heading, index) in tableData.headings"
            :key="index"
          >
            <div
              class="d-flex"
              v-if="index !== 0"
            >
              <div class="">{{ $t(heading) }}</div>
            </div>
            <div v-else>
              {{ $t(heading) }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(data, index) in tableData.datas"
          :key="index"
          @click="getSlipData(data.voucher)"
        >
          <th
            scope="row"
            v-for="(content, index) in tableData.contents"
            :key="index"
          >
            <div
              class="media d-flex"
              v-if="content === 'status'"
            >
              <span class="mb-0 text-md">
                <span
                  class="status-badge confirm"
                  v-if="data[content] === 'in'"
                >
                  {{ $t('transaction.in') }}
                </span>
                <span
                  class="status-badge fail"
                  v-if="data[content] === 'out'"
                >
                  {{ $t('transaction.out') }}
                </span>
              </span>
            </div>

            <div
              class="media align-items-center"
              v-else
            >
              <span class="name mb-0 text-md">{{
                (type === "unitList" && content !== "date"
                  ? Number(data[content]).toLocaleString()
                  : data[content]) || "-"
              }}</span>
            </div>
          </th>
        </tr>
        <tr v-if="type === 'unitList'">
          <th
            scope="row"
            class="pl-5"
          ></th>
          <th scope="row">
            Total -
            <b class="text-success">{{
              Number(totalUnitIn()).toLocaleString()
            }}</b>
          </th>
          <th scope="row">
            Total -
            <b class="text-success">{{
              Number(totalUnitOut()).toLocaleString()
            }}</b>
          </th>
          <th></th>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { DateTime } from "luxon";

export default {
  props: ["tableData", "type"],
  methods: {
    getSlipData(voucher) {
      if (voucher) {
        this.$emit("getSlipData", voucher);
      }
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString(
        "en-US",
        { timeZone: targetTimeZone }
      );
      return moment(adjustedDrawDate).format("lll");
    },
    totalUnitIn() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_in, 10);
      }
      return total;
    },
    totalUnitOut() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_out, 10);
      }
      return total;
    },
  },
};
</script>

<style scoped>
.history-table {
  display: block;
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper {
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper table {
  border-collapse: collapse;
  white-space: nowrap;
}

table th,
table td {
  padding: 1rem 1rem;
}
</style>
